import React, { useEffect, useState } from 'react';
import { Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { postLoginExterno } from 'app/features/Usuarios/usuariosAPI';
import { TIPOS_TRAMITE, TIPOS_USUARIO }  from 'constants/constants';
import { createSession } from 'utils/sessionManager';
import useQuery from 'customHooks/useQuery';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

const LoginValidacionBajaFallecimiento = () => {
    localStorage.setItem('token', "");
    localStorage.removeItem('usuario');
    const classes = useStyles();
    

    let query = useQuery();
    const [mensajePantalla, setMensajePantalla] = useState("cargando...");

    useEffect(() => {

        
        const usrData = { usuario: encodeURIComponent(query.get("usuario")), password: encodeURIComponent(query.get("pass")), idLegajoTemporal: query.get("id"), email: "", tpoTramite : 4 };
        postLoginExterno(usrData)
            .then((value) => {
                localStorage.clear();
                
                if (value.data.resultado) {

                    const session = {
                        ...value.data,
                        userType: TIPOS_USUARIO.SECRETARIO_TECNICO,
                        tpoTramite: TIPOS_TRAMITE.BAJA_FALLECIMIENTO,
                        validacionTitulo: true,
                        user: query.get("usuario"),
                        pass: query.get("pass")
                    }
                    createSession(session);

                    // localStorage.setItem('token', value.data.token);
                    // localStorage.setItem('idLegajoTemporal', value.data.idLegajoTemporal);
                    // localStorage.setItem('usuario', '');
                    // localStorage.setItem('usuarioValidarDatos', query.get("usuario"));
                    // localStorage.setItem('passValidarDatos', query.get("pass"));
                    // localStorage.setItem('idLegajo', value.data.legajoProfesional);
                    // localStorage.setItem('email', value.data.email);
                    // localStorage.setItem('userType', TIPOS_USUARIO.SECRETARIO_TECNICO);
                    // localStorage.setItem('validacionTitulo', 1);
                    // localStorage.setItem('usuario', value.data.usuarioInterno);

                    window.location.href = `/bajaFallecimiento`;
                    // dispatch(getMatriculasAsync({ idLegajoTemporal: value.data.idLegajoTemporal, token: value.data.token })).then((valor) => {

                    //     if (valor.payload.mensaje === "Legajo no encontrado!") {
                    //         setMensajePantalla("El legajo no existe");
                    //         return false;
                    //     }

                    //     const datosProfesional = JSON.parse(valor.payload.result.jsonDatos);

                       
                    // });

                } else {
                    setMensajePantalla("Usuario y/o contraseña incorrectos");
                }
            });
    }, []);

    return (
        <Paper className={classes.paper}>
            <Typography variant="subtitle1">
                {mensajePantalla}
            </Typography>
        </Paper>
    )
}

export default LoginValidacionBajaFallecimiento;
